module.exports = __webpack_public_path__ + "img/2-3.0ae1f911.png";